module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/AB1013-6a2aece0d37879b848ecdb09760b30fd.png";